import React from 'react';
import { Button } from '../ui';

function ProblemsOnlyToggle({ enabled, onChange, count }) {
  return (
    <div className="flex items-center gap-2">
      <Button
        variant="ghost"
        size="sm"
        type="button"
        onClick={() => onChange(false)}
        className={`px-4 py-2 rounded-lg font-medium text-sm transition-colors ${
          !enabled ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
        }`}
      >
        Show All
      </Button>
      <Button
        variant="ghost"
        size="sm"
        type="button"
        onClick={() => onChange(true)}
        className={`px-4 py-2 rounded-lg font-medium text-sm transition-colors ${
          enabled ? 'bg-red-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
        }`}
      >
        Problems Only {count > 0 && <span className="ml-1 bg-white text-red-600 rounded-full px-2 text-xs font-bold">{count}</span>}
      </Button>
    </div>
  );
}

export default ProblemsOnlyToggle;
